import { repository } from '@woc/woc-repository'
import { SalesPoint, SalesPointTag } from '@/model/sales-point'

export const salesPointRepository = repository.create({
  entity: 'salesPoint',
  url: 'sales-points',
  allow: 'crud',
  factory: data => new SalesPoint(data)
})

export const companySalesPointRepository = repository.create({
  entity: 'companySalesPoint',
  url: 'companies/:companyId/sales-points',
  allow: 'l',
  factory: data => new SalesPoint(data)
})

export const salesPointTagRepository = repository.create({
  entity: 'salesPointTag',
  url: 'sales-points/:salesPointId/tags',
  allow: 'lb',
  factory: data => new SalesPointTag(data)
})

export default repository.asModule(salesPointRepository, salesPointTagRepository, companySalesPointRepository)
